import React from 'react'

const columnWidths = [400, 200, 200, 200, 200, 200] // Type is wider, others are equal

const ScoreTable = ({ detailedScores }) => (
  <div className="w-full mt-5 max-md:max-w-full">
    <div className="flex w-full items-center gap-5 text-sm text-[#030303] font-medium leading-[1.2] max-md:max-w-full">
      <div className="self-stretch w-full flex-1 shrink basis-[0%] my-auto max-md:max-w-full">
        {/* Header Row */}
        <div className="flex w-full whitespace-nowrap text-center flex-wrap bg-neutral-50 border border-[#F0F0F0] rounded-t-[10px]">
          <div
            style={{ width: columnWidths[0] }}
            className="text-[#030303] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0] font-semibold"
          >
            Type
          </div>
          <div
            style={{ width: columnWidths[1] }}
            className="text-[#030303] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0] font-semibold"
          >
            English
          </div>
          <div
            style={{ width: columnWidths[2] }}
            className="text-[#030303] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0] font-semibold"
          >
            Mathematics
          </div>
          <div
            style={{ width: columnWidths[3] }}
            className="text-[#030303] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0] font-semibold"
          >
            Reading
          </div>
          <div
            style={{ width: columnWidths[4] }}
            className="text-[#030303] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0] font-semibold"
          >
            Science
          </div>
          <div
            style={{ width: columnWidths[5] }}
            className="text-[#030303] flex items-center justify-center px-5 py-3.5 font-semibold"
          >
            Total
          </div>
        </div>
        {/* Correct Row */}
        <div className="flex w-full whitespace-nowrap text-center flex-wrap bg-white border-l border-r border-b border-[#F0F0F0]">
          <div
            style={{ width: columnWidths[0] }}
            className="text-[#3BBC4C] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            Correct
          </div>
          <div
            style={{ width: columnWidths[1] }}
            className="flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.English.correct}
          </div>
          <div
            style={{ width: columnWidths[2] }}
            className="flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Math.correct}
          </div>
          <div
            style={{ width: columnWidths[3] }}
            className="flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Reading.correct}
          </div>
          <div
            style={{ width: columnWidths[4] }}
            className="flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Science.correct}
          </div>
          <div
            style={{ width: columnWidths[5] }}
            className="flex items-center justify-center px-5 py-3.5"
          >
            {detailedScores.Total.correct}
          </div>
        </div>
        {/* Incorrect Row */}
        <div className="flex w-full whitespace-nowrap text-center flex-wrap bg-white border-l border-r border-b border-[#F0F0F0]">
          <div
            style={{ width: columnWidths[0] }}
            className="text-[#E90004] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            Incorrect
          </div>
          <div
            style={{ width: columnWidths[1] }}
            className="text-[#E90004] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.English.incorrect}
          </div>
          <div
            style={{ width: columnWidths[2] }}
            className="text-[#E90004] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Math.incorrect}
          </div>
          <div
            style={{ width: columnWidths[3] }}
            className="text-[#E90004] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Reading.incorrect}
          </div>
          <div
            style={{ width: columnWidths[4] }}
            className="text-[#E90004] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Science.incorrect}
          </div>
          <div
            style={{ width: columnWidths[5] }}
            className="text-[#E90004] flex items-center justify-center px-5 py-3.5"
          >
            {detailedScores.Total.incorrect}
          </div>
        </div>
        {/* Omitted Row */}
        <div className="flex w-full whitespace-nowrap text-center flex-wrap bg-white border-l border-r border-b border-[#F0F0F0]">
          <div
            style={{ width: columnWidths[0] }}
            className="text-[#F36F4A] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            Omitted
          </div>
          <div
            style={{ width: columnWidths[1] }}
            className="text-[#F36F4A] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.English.omitted}
          </div>
          <div
            style={{ width: columnWidths[2] }}
            className="text-[#F36F4A] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Math.omitted}
          </div>
          <div
            style={{ width: columnWidths[3] }}
            className="text-[#F36F4A] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Reading.omitted}
          </div>
          <div
            style={{ width: columnWidths[4] }}
            className="text-[#F36F4A] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Science.omitted}
          </div>
          <div
            style={{ width: columnWidths[5] }}
            className="text-[#F36F4A] flex items-center justify-center px-5 py-3.5"
          >
            {detailedScores.Total.omitted}
          </div>
        </div>
        {/* Total Scale Score Row */}
        <div className="flex w-full whitespace-nowrap text-center flex-wrap bg-[#F0F0F0] rounded-b-[10px] border-l border-r border-b border-[#F0F0F0]">
          <div
            style={{ width: columnWidths[0] }}
            className="text-[#535862] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            Total Scale Score
          </div>
          <div
            style={{ width: columnWidths[1] }}
            className="text-[#535862] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.English.scaleScore}
          </div>
          <div
            style={{ width: columnWidths[2] }}
            className="text-[#535862] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Math.scaleScore}
          </div>
          <div
            style={{ width: columnWidths[3] }}
            className="text-[#535862] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Reading.scaleScore}
          </div>
          <div
            style={{ width: columnWidths[4] }}
            className="text-[#535862] flex items-center justify-center px-5 py-3.5 border-r border-[#F0F0F0]"
          >
            {detailedScores.Science.scaleScore}
          </div>
          <div
            style={{ width: columnWidths[5] }}
            className="text-[#535862] flex items-center justify-center px-5 py-3.5"
          >
            {detailedScores.Total.scaleScore}
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default ScoreTable
